import { render, staticRenderFns } from "./deviceCT.vue?vue&type=template&id=33156c0c&scoped=true"
import script from "./deviceCT.vue?vue&type=script&lang=js"
export * from "./deviceCT.vue?vue&type=script&lang=js"
import style0 from "./deviceCT.vue?vue&type=style&index=0&id=33156c0c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33156c0c",
  null
  
)

export default component.exports